export const ASSOERTMENT = 'ASSOERTMENT'
export const GLOBAL_PRODUCT_ATTRIBUTES = 'GLOBAL_PRODUCT_ATTRIBUTES'
export const LOOK_ATTRIBUTES = 'LOOK_ATTRIBUTES'
export const BUYING_SESSION_PRODUCT_ATTRIBUTES = 'BUYING_SESSION_PRODUCT_ATTRIBUTES'
export const LOOK_NAME = 'lookName'
export const BUYING_SESSION_PRODUCT_SALES_PERIOD = 'SALES_PERIOD'
export const BUYING_SESSION_PRODUCT_CHANNEL = 'CHANNEL'
export const NO_OF_FILTER_TO_SHOW = 5
export const CLUSTER_STATUS = 'CLUSTER_STATUS'
export const CLUSTER_STATUS_NAME = 'Cluster Status'
export const CLUSTER = 'CLUSTER'
export const LIST_VIEW_PRODUCT_ATTRIBUTES = [
  'modelDescription',
  'color',
  'colorSpecification',
  'serieDescription',
  'manufacturingType'
]

export const ACTIVITY_HIERARCHY_MAP = {
  SHOES: ['line'],
  'LEATHER GOODS': ['family', 'line']
}

export const GROUP_NAMES_MAPPING = {
  'original-family-name': 'family',
  'original-line-name': 'line',
  'original-activity-name': 'activity'
}

export enum ASSORTMENT_SOURCE {
  CLUSTER = 'CLUSTER',
  CLUSTER_GROUP = 'CLUSTER_GROUP'
}

export const KNOWN_FIXED_GROUPING = [
  {
    attributeId: 'original-activity-name',
    sortBy: 'asc'
  },
  {
    attributeId: 'original-family-name',
    sortBy: 'asc'
  },
  {
    attributeId: 'original-line-name',
    sortBy: 'asc'
  }
  // {
  //   attributeId: 'original-composition',
  //   sortBy: 'asc'
  // },
  // {
  //   attributeId: 'original-category-name',
  //   sortBy: 'asc'
  // }
]

export const PRODUCT_SPECIFICATION_OPTIONS = {
  NONE: 'none',
  PRODUCT_QUANTITY: 'productQty',
  DOOR_AND_SIZE_QTY: 'doorNSizeQty'
}

export const ORDER_UPDATE_TYPE = {
  UPDATE_SPECIFICATION: 'updateSpecification',
  UPDATE_SOURCE_DOOR: 'updateSourceDoor'
}

export const DEFAULT_ACTIVITY_HIERARCHY = ['family']
export * from './KeyCodes'
export * from './PlaceHolder'
export * from './ImageUploadFormData'
export * from './WholesaleTags'
export * from './ProductLayoutViews'
export * from './ExternalImages'
export * from './VIPJobStatuses'
export * from './VIPJobNames'
export * from './RestEndPoints'
export * from './Network'
export * from './DefaultConfig'
export * from './Errors'
export * from './FileMIMETypes'
export * from './LookCardSizes'
export * from './PlaceHolder'
export * from './ProductCardSizes'
export * from './RetailConstants'
export * from './SortAttributesList'
export * from './ViewTabs'
export * from './BuyingBoardOrder'
